export enum GraphDropDownTypes {
  SORT = 'sort',
  DOWNLOAD = 'download',
}

export enum SortLabels {
  VALUE_HIGH_TO_LOW = 'Value : High to low',
  VALUE_LOW_TO_HIGH = 'Value : Low to high',
  DEFAULT = 'Default',
}

export enum SortKeys {
  VALUE_HIGH_TO_LOW = 'false',
  VALUE_LOW_TO_HIGH = 'true',
  DEFAULT = 'default',
}

export enum DownloadLabels {
  PNG = 'PNG',
  JPG = 'JPG',
  CSV = 'CSV',
}

export enum DownloadKeys {
  PNG = 'png',
  JPG = 'jpg',
  CSV = 'csv',
  XLSX = 'xlsx',
}

export enum DownloadFileName {
  PRODUCT_LIFE_CYCLE_MAP = 'product_life_cycle',
  COMPANY_PRODUCTS_EMISSION = 'company_product_emission',
  COMPANY_ANNUAL_EMISSION = 'company_annual_emission',
  CARBON_ONE = 'carbon_one',
  PRODUCT_LIFE_CYCLE_STAGES_EMISSION = 'product_stages_emission',
}

export enum DownloadLoader {
  DOWNLOADING = 'Downloading...',
  UPLOADING = 'Uploading...',
}
